import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export interface ProblemReason { id: number; name: string; inUse: boolean; displayOrder: number; }
export interface ProblemCauseCount { reasonId: number | null; name: string; count: number; }

@Injectable({ providedIn: 'root' })
export class ProblemReasonService {
  private http = inject(HttpClient);
  private url = `${environment.apiUrl}/problem-reasons`;

  getAll() { return this.http.get<ProblemReason[]>(this.url); }
  updateOrder(reasonIds: number[]) { return this.http.put<ProblemReason[]>(`${this.url}/order`, { reasonIds }); }
  create(name: string) { return this.http.post<ProblemReason>(this.url, { name }); }
  update(id: number, name: string) { return this.http.put<ProblemReason>(`${this.url}/${id}`, { name }); }
  delete(id: number) { return this.http.delete<void>(`${this.url}/${id}`); }
  getPareto() { return this.http.get<ProblemCauseCount[]>(`${this.url}/pareto`); }
}
